// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__2j3i0","latest-submission":"News_latest-submission__3HSR3"};